import { HTTP, authHeader } from './http-service';

class DSARSearchService {
  search(payload) {
    return HTTP.post(`/DataSubjectAccessRequestSearch`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  advancedSearch(payload) {
    return HTTP.post(`/DataSubjectAccessRequestSearch/advance`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }
}

export default new DSARSearchService();
